import { all } from 'redux-saga/effects';

import uploadWatcher from './upload-document-saga';

export default function* rootSaga(action) {
    console.log("Saga")
    yield all([uploadWatcher(action)]);
}
